import { Button, SectionHelper } from '@wix/design-system';
import React from 'react';

type ContainerProps = {
  children: React.ReactNode;
  retryProp?: any;
};

export class ErrorBoundary extends React.Component<ContainerProps> {
  state: { error: null | Error } = { error: null };

  static getDerivedStateFromError(error: any) {
    console.error(error);
    return { error };
  }

  componentDidUpdate(prevProps: ContainerProps) {
    if (prevProps.retryProp !== this.props.retryProp) {
      this.setState({ error: null });
    }
  }

  render() {
    return this.state.error !== null ? (
      <div style={{ padding: 20 }} className="relative z-0 overflow-auto">
        <SectionHelper title="Component error while rendering" appearance="danger">
          {this.state.error.message}
          <div style={{ paddingTop: '12px' }}>
            <Button
              priority="secondary"
              size="small"
              onClick={() => this.setState({ error: null })}
              skin="dark"
            >
              Rerender
            </Button>
          </div>
        </SectionHelper>
      </div>
    ) : (
      this.props.children
    );
  }
}
